module.exports = {"510181001":"奎光塔街道","510181002":"幸福街道","510181004":"灌口街道","510181005":"银杏街道","510181006":"玉堂街道","510181007":"蒲阳街道","510181103":"聚源镇","510181105":"天马镇","510181106":"石羊镇","510181110":"青城山镇","510181111":"龙池镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510181.json
// module id = 2400
// module chunks = 0